import React, { useEffect, useState } from 'react';
import { WebinarPresentation } from './components/WebinarPresentation';
import { PresenterNotesView } from './components/PresenterNotesView';
export function App() {
  const [isPresenterView, setIsPresenterView] = useState(false);
  useEffect(() => {
    // Check URL parameter to determine which view to show
    const params = new URLSearchParams(window.location.search);
    if (params.get('view') === 'presenter') {
      setIsPresenterView(true);
      document.title = 'Presenter Notes - Viridia Webinar';
    }
  }, []);
  if (isPresenterView) {
    return <PresenterNotesView data-id="element-0" />;
  }
  return <WebinarPresentation data-id="element-1" />;
}